import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GetTransactionDetails
} from "../../Services/InsuranceApi";


const InsThankyou = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }

  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const key = getParamIgnoreCase("Key");
  const clientCode = getParamIgnoreCase("ClientCode");

  const [transactionData, setTransactionData] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    const fetchTransactionDetails =
      async () => {

        try {

          const params = {
            ReferenceNo: referenceNo,
            Key: key,
            ClientCode: clientCode,
          };

          const response = await GetTransactionDetails(params);

          console.log(
            "Transaction Details =>",
            response
          );

          setTransactionData(response);

        } catch (error) {

          //console.log(error);

        } finally {

          setLoading(false);

        }
      };

    if (referenceNo) {

      fetchTransactionDetails();

    } else {

      console.warn(
        "Missing referenceNo"
      );

      setLoading(false);
    }

  }, [referenceNo]);



  const booking =
    transactionData?.booking;

  const passengers =
    transactionData?.passengers || [];

  const payments =
    transactionData?.payments || [];

  const rider =
    transactionData?.rider || [];

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return "";

    return new Date(dateStr).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const paymentStatus = payments?.[0]?.paymentStatus?.toLowerCase() || "";
  const bookingStatus = booking?.bookingStatus?.toLowerCase() || "";

  const getStatusMessage = () => {
    // Payment Successful + Policy Confirmed
    if (
      bookingStatus === "confirmed" &&
      (paymentStatus === "success" || paymentStatus === "successful")
    ) {
      return {
        type: "success",
        title: "Policy Created Successfully (Confirmed)",
        message: (
          <>
            <p>Thank you for choosing us!</p>
            <p>
              Your insurance policy has been issued successfully. Please find
              your booking and policy details below.
            </p>
          </>
        ),
      };
    }

    // Payment Successful but Policy Pending
    if (
      bookingStatus === "bookinginitiated" &&
      (paymentStatus === "success" || paymentStatus === "successful")
    ) {
      return {
        type: "warning",
        title: "Policy Creation Pending",
        message: (
          <>
            <p>Thank you for your booking request.</p>
            <p>
              Your payment has been received, and your policy is currently being
              processed by the insurer. The policy document and policy number will
              be shared with you once the issuance is completed.
            </p>
            <p>
              Please check back later or contact our support team if you need
              assistance.
            </p>
          </>
        ),
      };
    }

    // Payment Pending + Policy Pending
    if (
      bookingStatus === "pending" &&
      (paymentStatus === "pending" || paymentStatus === "")
    ) {
      return {
        type: "warning",
        title: "Policy Creation Pending",
        message: (
          <>
            <p>Your booking request has been received.</p>
            <p>
              Your policy issuance is pending because the payment has not yet been
              confirmed. Once your payment is successfully processed, we will
              initiate the policy issuance.
            </p>
          </>
        ),
      };
    }

    // Payment Successful but Policy Failed
    if (
      bookingStatus === "failed" &&
      (paymentStatus === "success" || paymentStatus === "successful")
    ) {
      return {
        type: "danger",
        title: "Payment Successful but Policy Failed",
        message: (
          <>
            <p>Your payment was successful, but your policy could not be issued.</p>
            <p>
              We are currently reviewing the issue with the insurer. If the
              policy cannot be issued, the amount paid will be refunded or
              adjusted according to the insurer's and our refund policy.
            </p>
            <p>Our support team will keep you informed of the progress.</p>
          </>
        ),
      };
    }

    // Payment Failed + Policy Failed
    if (
      bookingStatus === "failed" &&
      (paymentStatus === "failed" || paymentStatus === "failure")
    ) {
      return {
        type: "danger",
        title: "Policy Creation Failed",
        message: (
          <>
            <p>
              Your policy could not be issued because the payment was
              unsuccessful.
            </p>
            <p>
              No amount has been charged. Please try booking again or contact our
              support team if the issue persists.
            </p>
          </>
        ),
      };
    }

    // Policy Failed (Unknown/ Technical Issue)
    if (bookingStatus === "failed") {
      return {
        type: "danger",
        title: "Policy Creation Failed",
        message: (
          <>
            <p>
              We regret to inform you that your policy could not be issued.
            </p>
            <p>
              Unfortunately, we were unable to create your insurance policy due to
              a technical issue or insurer response.
            </p>
            <p>
              If your payment has been deducted, it will be refunded or reconciled
              as per the applicable policy. Please contact our support team for
              further assistance.
            </p>
          </>
        ),
      };
    }

    return null;
  };

  const statusInfo = getStatusMessage();

  return (
    <>
      <Header />

      <section className="Booking_flight">
        <div className="container">
          <div className="box_shadow">

            <div className="col-md-12">
              <div className="booking-confirmation clearfix mt-5">
                {statusInfo && (
                  <div className={`alert alert-${statusInfo.type} mt-4`}>
                    <h4 className="mb-2">{statusInfo.title}</h4>
                    {statusInfo.message}
                  </div>
                )}
                <div className='col-md-12 col-lg-12'>
                  <h6 class="ruler">Booking Details</h6>
                  <table className="table table-bordered responsive-table">
                    <thead>
                      <tr>
                        <th>Reference No</th>
                        <th>Policy No</th>
                        <th>Booking Status</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>{booking?.referenceNo}</td>
                        <td>{booking?.policyNumber}</td>
                        <td>
                          <span
                            style={{
                              color: booking?.bookingStatus === "Confirmed" ? "green" : "red",
                            }}
                          >
                            <b>{booking?.bookingStatus}</b>
                          </span>
                        </td>
                        <td>{booking?.startDate}</td>
                        <td>{booking?.endDate}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>

                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Policy Details</h6>
                  <div className='table-responsive'>
                    <table className="table table-bordered responsive-table">
                      <thead>
                        <tr>
                          <th>PolicyNo</th>
                          <th>Insurer Name</th>
                          <th>Plan Name</th>
                          <th>Duration</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{booking?.policyNumber}</td>
                          <td>{booking?.insuranceName}</td>
                          <td>{booking?.planName}</td>
                          <td>{booking?.duration} Days</td>
                          <td>{booking?.bookingStatus}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-md-12 col-lg-12">

                  <h6 className="ruler">
                    Transaction Summary
                  </h6>

                  <div className="table-responsive">

                    <table className="table table-bordered responsive-table">

                      <thead>
                        <tr>
                          <th>Payment Status</th>
                          <th>Transaction ID</th>
                          <th>Amount Paid</th>
                          <th>Payment Date</th>
                        </tr>
                      </thead>

                      <tbody>

                        {payments.map(
                          (item, index) => (
                            <tr key={index}>

                              <td>
                                {item?.paymentStatus}
                              </td>

                              <td>
                                {item?.transactionID}
                              </td>

                              <td>
                                ₹ {item?.amountPaid}
                              </td>

                              <td>
                                {item?.creationDate
                                  ? new Date(item.creationDate).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  })
                                  : "-"}
                              </td>

                            </tr>
                          )
                        )}

                      </tbody>

                    </table>

                  </div>

                </div>

              </div>
            </div>
            <div class="col-md-12 text-right">
              <a class="redirect" href={`/reservations/insurance/TransactionsDetails?referenceNo=${transactionData?.referenceNo}&key=${transactionData?.key}&clientCode=${transactionData?.clientCode}`}>
                View Booking Details </a></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InsThankyou;